import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Donation from '@/views/Donation'
import DonationDetail from '@/views/DonationDetail'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Donation',
      component: Donation
    },
    {
      path: '/bagislarim',
      name: 'MyDonations',
      meta: { auth: true },
      component: () => import('@/views/MyDonations.vue')
    },
    {
      path: '/bagislarim/:id',
      name: 'DonationTableDetail',
      meta: { auth: true },
      component: () => import('@/views/MyDonationDetail.vue')
    },
    {
      path: '/ayarlar',
      name: 'MySettings',
      meta: { auth: true },
      component: () => import('@/views/MySettings.vue')
    },
    /* {
      path: '/iletisim',
      name: 'Contact',
      component: () => import('@/views/Contact.vue')
    }, */
    {
      path: '/i/:slug',
      name: 'Content',
      component: () => import('@/views/Content.vue')
    },
    {
      path: '/odeme-sonuc/:id',
      name: 'PaymentResult',
      component: () => import('@/views/PaymentResult.vue')
    },
    {
      path: '/medya/:id/:token',
      name: 'DonationImage',
      component: () => import('@/views/DonationImage.vue')
    },
    {
      path: '/kvideo/:id/:token',
      name: 'QurbanVideo',
      component: () => import('@/views/QurbanVideo.vue')
    },
    {
      path: '/sitemap',
      name: 'Sitemap',
      component: () => import('@/views/Sitemap')
    },
    {
      path: '/404',
      name: 'NotFound',
      component: () => import('@/views/NotFound')
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/:id',
      name: 'DonationDetail',
      component: DonationDetail
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// router guard
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (!store.state.user.loggedIn) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
